import React from 'react';
import '../styles/tavern-components.css';

export interface TavernButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  fullWidth?: boolean;
  children: React.ReactNode;
}

/**
 * Tavern-styled button component
 * 
 * @example
 * <TavernButton variant="primary" onClick={handleClick}>
 *   Accept Quest
 * </TavernButton>
 * 
 * @example
 * <TavernButton variant="secondary" disabled>
 *   Not Available
 * </TavernButton>
 */
export function TavernButton({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: TavernButtonProps) {
  const variantClass =
    variant === 'primary'
      ? 'ttbButtonPrimary'
      : variant === 'secondary'
      ? 'tavern-btn-secondary'
      : 'tavern-btn-danger';

  const widthClass = fullWidth ? '' : '';

  return (
    <button
      className={`${variantClass} ${widthClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export interface TavernIconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  variant?: 'default' | 'danger';
  ariaLabel: string;
}

/**
 * Small circular icon button for tavern theme
 * 
 * @example
 * <TavernIconButton 
 *   icon="✕" 
 *   variant="danger" 
 *   ariaLabel="Remove participant"
 *   onClick={handleRemove}
 * />
 */
export function TavernIconButton({
  icon,
  variant = 'default',
  ariaLabel,
  className = '',
  ...props
}: TavernIconButtonProps) {
  const variantClass =
    variant === 'danger' ? 'tavern-btn-icon--danger' : '';

  return (
    <button
      className={`tavern-btn-icon ${variantClass} ${className}`.trim()}
      aria-label={ariaLabel}
      {...props}
    >
      {icon}
    </button>
  );
}
